'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Dropbox';

var EntypoDropbox = function EntypoDropbox(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M6.109,0.902L0.4,4.457l3.911,3.279L10,4.043L6.109,0.902z M13.452,15.992c-0.102,0-0.203-0.033-0.285-0.102L10,13.262l-3.167,2.629c-0.082,0.068-0.184,0.102-0.285,0.102c-0.085,0-0.17-0.023-0.244-0.072l-2.346-1.533v0.904L10,19.098l6.042-3.807v-0.904l-2.346,1.533C13.622,15.969,13.537,15.992,13.452,15.992z M19.6,4.457l-5.71-3.555L10,4.043l5.688,3.693L19.6,4.457z M10,11.291l3.528,2.928l5.641-3.688l-3.481-2.795L10,11.291z M6.472,14.219L10,11.291L4.311,7.736l-3.48,2.795L6.472,14.219z' })
    );
};

exports.default = EntypoDropbox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/Dropbox.js
// module id = ./node_modules/react-entypo/lib/entypo/Dropbox.js
// module chunks = 2